import { createStyles } from '@mantine/core';

import { textStyles } from '~/domains/design-system/Text';

const useStyles = createStyles((theme, { isMobile }: { isMobile: boolean }) => ({
  tabOverride: {
    '& .mantine-Tabs-tabsList': {
      background: isMobile ? 'white' : 'transparent',
      paddingLeft: '0 !important',
      paddingRight: '0 !important',
      ...(isMobile
        ? {
            margin: /* eslint-disable-line local-rules/use-theme-tokens */ '-16px -24px 0',
            padding: /* eslint-disable-line local-rules/use-theme-tokens */ '0 24px',
            gap: 0,
          }
        : {}),
    },
  },
  pillsList: {
    background: 'transparent !important',
    border: 'none',
    gap: /* eslint-disable-line local-rules/use-theme-tokens */ '8px',
    paddingLeft: '0 !important',
    paddingRight: '0 !important',
  },
  pill: {
    padding: '6px 16px !important',
    ...textStyles['subhead-small'],
    border: `1px solid ${theme.colors.gray[4]}`,
    borderRadius: /* eslint-disable-line local-rules/use-theme-tokens */ '100px',

    span: {
      color: theme.colors.gray[9],
    },

    '&[aria-selected="true"]': {
      background: theme.colors.gray[9],
      borderColor: theme.colors.gray[9],
      span: {
        color: theme.white,
      },
    },

    '&:hover': {
      background: theme.colors.gray[4],
      borderColor: theme.colors.gray[4],
      span: {
        color: theme.colors.gray[9],
      },
    },
  },
}));

export default useStyles;
